import createContext from '../utils/createContext';
export default createContext(null);